import "./index.css";
import React, { Fragment, createRef } from "react";
import { CurrencyOptions } from "../../../../Constants/retailer";
import Checkbox from "../../../BespokeCRMTabs/components/Checkbox";
import AddressInput from "../../../../components/AddressInput";
import AddProductGuide from "./components/AddProductGuide";
import RadioGroup from "./components/RadioGroup";
import UploadPanel from "../../../../components/UploadPanel";
import { getFilePath } from "../../../../Utils/utils";
import Firebase from "../../../../firebasehelper";
import { YOUTUBE_URL } from "../../../../Constants/types";
import SingleFileUpload from "../../../ProductPortfolio/components/SingleFileUpload";
import TokenPriceInput from "./components/TokenPriceInput";
import ProductPriceInput from "./components/ProductPriceInput";
import {
  paymentMethodOptions,
  paymentTypeOptions,
  productTypeOptions,
  saleTypeOptions,
  splittableOptions,
  EYE_LINE_ADS_ID,
} from "../constants";
import PaymentFrequencyInput from "./components/PaymentFrequencyInput";

class Popup extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      contents: ["", "", "", ""],
      caption: "",
      description: "",
      price: {
        amount: 4000,
        frequency: "per_item",
      },
      productType: productTypeOptions[0],
      paymentType: paymentTypeOptions[1],
      paymentMethod: paymentMethodOptions[0],
      saleType: saleTypeOptions[1],
      splittable: splittableOptions[0],
      isgroup: "no",
      threshold: 0,
      media: [],
      isGeoLocated: true,
      address: null,
      isGuideOpen: false,
      productLogoPreview: "",
      productLogoFile: null,
    };
    this.modalRef = createRef();
    this.saveBtnRef = createRef();
  }
  componentDidMount() {
    const { brandId } = this.props;
    brandId === EYE_LINE_ADS_ID &&
      this.setState({ paymentMethod: paymentMethodOptions[1] });

    document.addEventListener("mousedown", this.onOutsideClick);
  }
  componentWillUnmount() {
    document.removeEventListener("mousedown", this.onOutsideClick);
  }
  onChangeHandler = (e) => {
    this.setState({ [e.target.name]: e.target.value });
  };
  onChangeContent = (e) => {
    let { contents } = this.state;
    let id = e.target.id;
    contents[id] = e.target.value;
    this.setState({ contents });
  };
  onPaymentTypeChange = (paymentType) => {
    this.setState({ paymentType });
  };
  onSaleTypeChanged = (saleType) => {
    this.setState({ saleType });
  };
  onSplittableChanged = (splittable) => {
    this.setState({ splittable });
  };
  onProductTypeChange = (productType) => {
    const isPhysical = productType.value === "physical";

    this.setState({
      productType: productType,
      price: {
        amount: isPhysical ? 4000 : 100,
        frequency: "per_item",
      },
      splittable: isPhysical ? splittableOptions[1] : splittableOptions[0],
      isGeoLocated: isPhysical,
      paymentType: !isPhysical
        ? { id: "quickbuy", label: "Single buy", value: "quickbuy" }
        : this.state.paymentType,
    });
  };
  onOutsideClick = (e) => {
    if (!this.modalRef.current.contains(e.target)) {
      // using timeout here for better UX
      setTimeout(() => {
        this.onCloseModal();
      }, 300);
    }
  };
  addPackage = () => {
    const { addPackage } = this.props;
    const isInputValid = this.isValidInput();
    if (isInputValid) {
      addPackage(this.state);
      this.saveBtnRef.current.click();
      this.resetFormFields();
    } else this.setState({ isGuideOpen: true });
  };

  isValidInput = () => {
    const {
      caption,
      description,
      contents,
      media,
      address,
      isGeoLocated,
      price,
    } = this.state;

    const hasAtleastOneMediaType = media.find((item) => item) ? true : false;
    const hasTitleAndDescription = caption.length > 0 && description.length > 0;
    const ifGeoDoesItHaveAddress = isGeoLocated ? address !== null : true;
    const hasAtleastOneBulletPoint = contents[0].length > 0;
    const hasPrice = price.amount ? true : false;

    return (
      hasTitleAndDescription &&
      hasAtleastOneMediaType &&
      ifGeoDoesItHaveAddress &&
      hasAtleastOneBulletPoint &&
      hasPrice
    );
  };

  showContent = () => {
    let { contents } = this.state;
    return contents.map((item, index) => {
      return (
        <div className="benefit">
          -
          <input
            type="text"
            placeholder="Input benefit here.."
            id={index}
            onChange={this.onChangeContent}
            value={item}
          />
        </div>
      );
    });
  };

  resetFormFields = () => {
    // hack to reset address
    this.setState({ isGeoLocated: false });

    this.setState({
      contents: ["", "", "", ""],
      caption: "",
      description: "",
      price: {
        amount: 4000,
        frequency: "per_item",
      },
      productType: productTypeOptions[0],
      paymentType: paymentTypeOptions[1],
      paymentMethod: paymentMethodOptions[0],
      saleType: saleTypeOptions[1],
      splittable: splittableOptions[0],
      isgroup: "no",
      threshold: 0,
      media: [],
      isGeoLocated: true,
      address: null,
      isGuideOpen: false,
      shouldResetYoutubeInput: true,
      productLogoPreview: "",
      productLogoFile: null,
    });
  };

  onSelectAddress = (addressObj) => this.setState({ address: addressObj });

  closeGuideModal = () => this.setState({ isGuideOpen: false });

  onPaymentMethodChange = (newPaymentMethod) =>
    this.setState({ paymentMethod: newPaymentMethod });

  deleteUploadedMediaOnClose = async () => {
    const deletePromises = this.state.media.map((item) => {
      if (item && item.mediaType !== YOUTUBE_URL) {
        const path = getFilePath("packages", item.mediaUrl, item.mediaType);
        return Firebase.deleteFile(path);
      }
    });
    await Promise.all(deletePromises);
  };

  onCloseModal = async () => {
    await this.deleteUploadedMediaOnClose();
    this.resetFormFields();
  };

  updateState = (stateObject) => this.setState(stateObject);

  onDeleteLogo = () => {
    this.setState({ productLogoPreview: "", productLogoFile: null });
  };

  onPriceChange = (key, value) => {
    const updatedValue = key === "amount" ? value * 100 : value;

    this.setState((prevState) => ({
      price: {
        ...prevState.price,
        [key]: updatedValue,
      },
    }));
  };

  render() {
    const { territory, white, hex, brandId } = this.props;
    const {
      contents,
      caption,
      description,
      productType,
      paymentType,
      price,
      saleType,
      splittable,
      threshold,
      media,
      isGeoLocated,
      isGuideOpen,
      paymentMethod,
      shouldResetYoutubeInput,
      productLogoPreview,
    } = this.state;

    const isInputValid = this.isValidInput();
    return (
      <div
        className="modal fade"
        id="package_popup"
        tabIndex="-1"
        role="dialog"
        aria-labelledby="modal-default-fadein"
        aria-hidden="true"
      >
        <div className="modal-dialog" style={{ maxWidth: 700 }} role="document">
          <div className="modal-content" ref={this.modalRef}>
            <div className="modal-header">
              <h5 className="modal-title">Create Product</h5>
              <button
                type="button"
                className="close"
                data-dismiss="modal"
                aria-label="Close"
                onClick={this.onCloseModal}
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body package-modal-container">
              <label className="popup__label">Name</label>
              <input
                type="text"
                className="form-control form-control-lg form-control-alt"
                name="caption"
                onChange={this.onChangeHandler}
                placeholder="Type product name"
                value={caption}
              />
              {process.env.REACT_APP_USER === "admin" && (
                <RadioGroup
                  title="Is the product physical or digital?"
                  selectedOption={productType}
                  options={productTypeOptions}
                  hex={hex}
                  onClick={this.onProductTypeChange}
                />
              )}
              <RadioGroup
                title="How will the product be received?"
                selectedOption={paymentType}
                options={paymentTypeOptions}
                hex={hex}
                onClick={this.onPaymentTypeChange}
                disabled={productType.value === "digital"}
              />
              <h3
                className={`popup__question ${
                  productType.value === "digital" ? "popup--disabled" : ""
                }`}
              >
                Is the product redeemable in a location?
              </h3>
              <Checkbox
                label="Geo-located"
                checked={isGeoLocated}
                onChange={() => this.setState({ isGeoLocated: !isGeoLocated })}
                hex={hex}
                white={white}
                classNames={`checkbox--no-margin-top popup__checkbox ${
                  productType.value === "digital" ? "popup--disabled" : ""
                }`}
              />
              {isGeoLocated && (
                <AddressInput
                  onGetAddress={this.onSelectAddress}
                  hex={hex}
                  white={white}
                />
              )}

              {productType.value === "digital" ? (
                <TokenPriceInput
                  amount={price.amount}
                  territory={territory}
                  onChange={(e) => this.onPriceChange("amount", e.target.value)}
                />
              ) : (
                <div className="price__container">
                  <ProductPriceInput
                    amount={price.amount}
                    territory={territory}
                    onChange={(e) =>
                      this.onPriceChange("amount", e.target.value)
                    }
                  />
                  <PaymentFrequencyInput
                    onPaymentFrequencyChange={(option) =>
                      this.onPriceChange("frequency", option.value)
                    }
                    white={white}
                    hex={hex}
                    value={price.frequency}
                  />
                </div>
              )}
              <SingleFileUpload
                label="Product logo"
                logoPreview={productLogoPreview}
                setLogoPreview={(imagePath) =>
                  this.updateState({ productLogoPreview: imagePath })
                }
                hex={hex}
                white={white}
                updateState={(file) =>
                  this.updateState({ productLogoFile: file })
                }
                onDelete={this.onDeleteLogo}
              />

              <label className="popup__label">Product Introduction</label>
              <textarea
                className="form-control form-control-lg form-control-alt"
                name="description"
                value={description}
                placeholder="Keep it short and snappy."
                onChange={this.onChangeHandler}
              />
              <label className="popup__label">Product content</label>
              <UploadPanel
                media={media}
                updateState={this.updateState}
                brandId={brandId}
                hex={hex}
                white={white}
                shouldReset={shouldResetYoutubeInput}
                uploadDirectory="packages"
              />
              <label className="popup__label">Product features</label>
              {contents.slice(0, 4).map((item, index) => (
                <input
                  type="text"
                  className="form-control form-control-lg form-control-alt content-input"
                  id={index}
                  onChange={this.onChangeContent}
                  value={item}
                  key={index}
                />
              ))}
              <RadioGroup
                title="Is the product available to purchase?"
                selectedOption={saleType}
                options={saleTypeOptions}
                hex={hex}
                onClick={this.onSaleTypeChanged}
              />
              {brandId !== EYE_LINE_ADS_ID && (
                <Fragment>
                  <RadioGroup
                    title="Can the product be split between a group?"
                    selectedOption={splittable}
                    options={splittableOptions}
                    hex={hex}
                    onClick={this.onSplittableChanged}
                    disabled={productType.value === "digital"}
                  />
                  <RadioGroup
                    title="How is this product redeemable?"
                    selectedOption={paymentMethod}
                    options={paymentMethodOptions}
                    hex={hex}
                    onClick={this.onPaymentMethodChange}
                  />

                  <div
                    className={`threshold-container ${
                      paymentType.value === "subscription" ||
                      paymentMethod.value === "cash"
                        ? "popup--disabled"
                        : ""
                    }`}
                  >
                    <label>Tokens redeemed</label>
                    <div className="input-group">
                      <div className="prefix">{CurrencyOptions[territory]}</div>
                      <input
                        type="number"
                        className="form-control form-control-md form-control-alt threshold"
                        placeholder="Spend threshold"
                        name="threshold"
                        onChange={this.onChangeHandler}
                        value={threshold}
                      />
                    </div>
                  </div>
                </Fragment>
              )}
            </div>
            <div
              className="modal-footer"
              style={{ justifyContent: "space-around" }}
            >
              <button
                type="button"
                className="btn btn-brand-hex btn-white"
                style={{
                  "--hover-text-color": white ? "white" : "black",
                  "--hover-color": hex,
                  backgroundColor: "white",
                  color: "black",
                }}
                data-dismiss="modal"
                onClick={this.onCloseModal}
              >
                Cancel <span className="popup__btn-label">listing</span>
              </button>
              <button
                type="button"
                className={`btn btn-green ${
                  isInputValid ? "" : "popup__btn--invalid"
                }`}
                onClick={this.addPackage}
              >
                List <span className="popup__btn-label">product</span>
              </button>
              <button
                type="button"
                style={{ display: "none" }}
                data-dismiss="modal"
                ref={this.saveBtnRef}
              />
              {isGuideOpen && (
                <AddProductGuide
                  onClick={this.closeGuideModal}
                  hex={hex}
                  white={white}
                />
              )}
            </div>
          </div>
        </div>
      </div>
    );
  }
}
export default Popup;



// WEBPACK FOOTER //
// ./src/screens/super_products/components/Popup/index.js